import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { getDashboardTokens } from '../../api'
import { DashboardTokensTypeAPI } from '../../api/types'
import { Loading } from '../../components/shared/Loading'
import { useUser } from '../../contexts/User'
import { TabIndicator } from '../../elements/TabIndicator'
import { getPaths } from '../../routing/routes'

import styles from './DashboardPage.module.scss'


export const DASHBOARD_TAB_NAMES = {
  sales_dashboard: {
    token_id: 'salesDashboardToken'
  },
  management_dashboard: {
    token_id: 'managementDashboardToken'
  }
} as const
export type DashboardTabNameType = keyof typeof DASHBOARD_TAB_NAMES

export type DashboardPageProps = {
  tab: DashboardTabNameType
}


export const DashboardPage = ({ tab }: DashboardPageProps) => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  const { hasPermissions } = useUser()

  const [loading, setLoading] = useState(true)
  const [dashboardTokens, setDashboardTokens] = useState<DashboardTokensTypeAPI>()


  const tabs = useMemo(() => {
    const tabsArray = [{
      id: 'sales_dashboard',
      title: i18n.t('Dashboard:Sales'),
      onClick: () => navigate(getPaths.brands.dashboard.tab('sales_dashboard'))
    }]
    if (hasPermissions('management_dashboard_viewer')) {
      tabsArray.push({
        id: 'management_dashboard',
        title: i18n.t('Dashboard:Management'),
        onClick: () => navigate(getPaths.brands.dashboard.tab('management_dashboard'))
      })
    }

    return tabsArray
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPermissions])


  useEffect(() => {
    getDashboardTokens().then(response => {
      if (!response.success) {
        toast.error(i18n.t('ToastError:DashboardsNotFound'), { autoClose: 2600, pauseOnHover: false })
        setTimeout(() => {
          navigate(getPaths.brands.missions.ongoing)
        }, 3000);
        return
      }
      setDashboardTokens(response.data)

      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <h1>
        {i18n.t('Common:Dashboard')}
      </h1>
      <TabIndicator
        currentTab={tab}
        disabled={loading}
        tabsLeft={tabs}
      />
      {loading ? (
        <Loading />
      ) : (
        /* eslint-disable i18next/no-literal-string */
        <metabase-dashboard
          className={styles.dashboard}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          token={dashboardTokens![DASHBOARD_TAB_NAMES[tab].token_id]}
          with-title='false'
          with-downloads='true'
          // /!\ ISSUE: guestEmbedProviderUri from metabase not working /!\ \\
          // custom-context={{
          //   "manager_email": cookies.email,
          //   "dashboard_type": tab.replace('_dashboard', ''),
          //   // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          //   "token": dashboardTokens![DASHBOARD_TAB_NAMES[tab].token_id]
          // }}
        ></metabase-dashboard>
        /* eslint-enable i18next/no-literal-string */
      )}
    </>
  )
}
